<!-- cart empty -->
<a
  class="white pv3 relative-ns w-2"
  [jbSitemapLinker]="shoppingCart.emptyCart[0].link[0].href"
  [attr.target]="shoppingCart.emptyCart[0].link[0].newWindow"
  [attr.aria-label]="shoppingCart.emptyCart[0].alt"
>
  <jb-image
    [src]="shoppingCart.emptyCart[0].src"
    class="fl pointer fill-white shopping-cart flex justify-center"
  ></jb-image>
</a>
<!-- end cart empty -->
